export const isJsonResponse=contentType=>contentType&&contentType.includes("application/json");
//# sourceMappingURL=remote-data-util.js.map